import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tab-navigation',
  templateUrl: './tab-navigation.html',
  styleUrl: './tab-navigation.scss',
  standalone: true,
})
export class TabNavigation {
  @Input() activeTab = 'main';
  @Input() tabs: { label: string; id: string }[] = [];
  @Output() tabChange = new EventEmitter<string>();
}
